import { Money } from "../../utils/money";
import { BranchType } from "../delivery-company/branches";

export enum BranchInvoiceState {
    PENDING_PAYMENT = "PENDING_PAYMENT",
    PAYMENT_SCHEDULED = "PAYMENT_SCHEDULED",
    COLLECTED_BY_DRIVER = "COLLECTED_BY_DRIVER",
    IN_PROGRESS = "IN_PROGRESS",
    AWAITING_RETURN = "AWAITING_RETURN",
    PAID = "PAID",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
}

export interface IBranchInvoice {
    id: string;
    from_branch: BranchType;
    to_branch: BranchType;
    amount: Money[];
    status: BranchInvoiceState;
    created_at: string;
    notes?: string[];
}


